export default __webpack_public_path__ + "static/media/PowerGrotesk-UltraBold.c4d251fd.otf";